import React, { useEffect, useState } from 'react';
import { Col, Row, Form, FloatingLabel } from 'react-bootstrap';
import HVASpinner from 'components/base/HVASpinner';
import CallResultsFilter from './callresults/CallResultsFilter';
import { fetchHVACampaignNames } from 'services/hvaservicecampaign.service';

interface Campaign {
  id: number;
  name: string;
  bxpcampaignid: number;
}

const CallResultsReport = () => {
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [selectedCampaign, setSelectedCampaign] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Cargar las campañas
  useEffect(() => {
    const loadCampaigns = async () => {
      setIsLoading(true);
      try {
        // Sustituye con tu función real para cargar las campañas
        const campaignNames = await fetchHVACampaignNames();
        if (Array.isArray(campaignNames)) {
          setCampaigns(campaignNames);
        } else {
          throw new Error('Invalid response format');
        }
      } catch (error) {
        if (error instanceof Error) {
          setError('Error loading campaigns: ' + error.message);
        } else {
          setError('Unknown error occurred while loading campaigns');
        }
      } finally {
        setIsLoading(false);
      }
    };

    loadCampaigns();
  }, []);

  // Controlador para manejar la selección de campaña
  const handleCampaignChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCampaign(e.target.value);
  };

  return (
    <>
      <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 pt-0 pb-0 mb-0">
        <Row className="gy-3 mb-1 justify-content-between">
          <Col>
            <h2 className="mb-2 text-body-emphasis">Call Results Report</h2>
            <h5 className="text-body-tertiary fw-semibold">
              Start by selecting a campaign
            </h5>
          </Col>
          <Col>
            <div className="d-flex w-100 align-items-center">
              <FloatingLabel
                controlId="campaigns"
                label="Campaign selection"
                className="w-100"
              >
                {isLoading ? (
                  <HVASpinner />
                ) : (
                  <Form.Select
                    id="campaign"
                    value={selectedCampaign ?? ''}
                    onChange={handleCampaignChange}
                  >
                    <option value="">Select a campaign</option>
                    {campaigns.map(campaign => (
                      <option
                        key={campaign.id}
                        value={campaign.bxpcampaignid.toString()}
                      >
                        {campaign.name}
                      </option>
                    ))}
                  </Form.Select>
                )}
              </FloatingLabel>
            </div>
          </Col>
        </Row>

        {/* Mostrar un mensaje de error si hay problemas al cargar las campañas */}
        {error && <div className="text-danger mt-3">{error}</div>}
      </div>
      <div id="Content" className="mx-n4 px-4 mx-lg-n6 px-lg-6">
        {/* Mostramos el componente de filtros y la información de la campaña seleccionada */}
        {selectedCampaign ? (
          <CallResultsFilter bxpcampaignid={Number(selectedCampaign)} />
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default CallResultsReport;
